import ezorder from "../api/ezorderNoAuth";
import moment from "moment/moment";
import { Buffer } from "buffer";
const toThreeDecimals = (num) => Number(parseFloat(num).toFixed(3)); // Use for all measurements and calc
const toTwoDecimals = (num) => parseFloat(parseFloat(num).toFixed(2)); // Use for Dollars and Hours
const toFourDecimals = (num) => parseFloat(parseFloat(num).toFixed(4)); // Use for GROSS PROFIT (STORED AS DECIMAL) then 100xed

const applyMarkup = (value, markUpPercentage) => {
  let multiplier = 1 + markUpPercentage / 100.0;
  return toThreeDecimals(value * multiplier);
};

const SECTION_MARGIN = 12;
const FULL_WIDTH = 515;
const COLUMN_GAP = 20;
const HALF_COLUMN_WITH_GAP = (FULL_WIDTH - COLUMN_GAP) / 2;

const HEADER = (includeVendorLogo, vendorLogo, vendorLogoDimensions) => {
  if (vendorLogo && includeVendorLogo) {
    // Calculate Margin/Padding Top needed to center image
    let maxWidth = 100;
    let maxHeight = 55;
    let vendorLogoWidth = parseFloat(vendorLogoDimensions.w);
    let vendorLogoHeight = parseFloat(vendorLogoDimensions.h);
    let widthToHeightRatio = vendorLogoWidth / vendorLogoHeight;

    if (vendorLogoWidth > maxWidth) {
      vendorLogoWidth = maxWidth;
      vendorLogoHeight = vendorLogoWidth / widthToHeightRatio;
    }

    if (vendorLogoHeight > maxHeight) {
      vendorLogoHeight = maxHeight;
      vendorLogoWidth = vendorLogoHeight * widthToHeightRatio;
    }

    let marginTopToCenter = 0;
    if (vendorLogoHeight < maxHeight) {
      let heightDif = maxHeight - vendorLogoHeight;
      marginTopToCenter = heightDif / 2;
    }

    return [
      {
        columns: [
          {
            image: "logo",
            width: 70,
          },
          {
            image: "vendorLogo",
            fit: [maxWidth, maxHeight],
            margin: [0, marginTopToCenter, 0, 0],
          },
          {
            // text: "Project Quote",
            text: "Order Confirmation",
            style: "header",
            margin: [0, 20, 0, 0],
          },
        ],
        columnGap: 20,
        margin: [0, 0, 0, 8], // margin: [left, top, right, bottom]
      },
    ];
  } else {
    return [
      {
        columns: [
          {
            image: "logo",
            width: 120,
          },
          {
            text: "Order Confirmation",
            style: "header",
          },
        ],
        columnGap: 10,
        margin: [0, 0, 0, 8], // margin: [left, top, right, bottom]
      },
    ];
  }
};

const LINE_TOP = () => {
  return [
    {
      canvas: [{ type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }],
    },
  ];
};

const LINE_BELOW = () => {
  return [
    {
      canvas: [{ type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }],
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
  ];
};

const formatDate = (date) => {
  const yyyy = date.getFullYear();
  let mm = date.getMonth() + 1; // Months start at 0!
  let dd = date.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedDate = mm + "/" + dd + "/" + yyyy;
  return formattedDate;
};

const QUADRANT = (cell1, cell2, cell3, cell4) => {
  return {
    layout: "noBorders", // optional
    table: {
      // headers are automatically repeated if the table spans over multiple pages
      // you can declare how many rows should be treated as headers
      widths: [HALF_COLUMN_WITH_GAP - 1, HALF_COLUMN_WITH_GAP - 1],
      dontBreakRows: true,
      body: [
        [cell1, cell2],
        [cell3, cell4],
      ],
    },
  };
};

const OCTANT = (cell1, cell2, cell3, cell4, cell5, cell6, cell7, cell8) => {
  return {
    layout: "noBorders", // optional
    table: {
      // headers are automatically repeated if the table spans over multiple pages
      // you can declare how many rows should be treated as headers
      widths: [HALF_COLUMN_WITH_GAP - 1, HALF_COLUMN_WITH_GAP - 1],
      dontBreakRows: true,
      body: [
        [cell1, cell2],
        [cell3, cell4],
        [cell5, cell6],
        [cell7, cell8],
      ],
    },
  };
};

/* 
  Chop Contact Email if 29 characters (add space)
  pdfMake wraps text to next line only if there are spaces. If one word is too long for the column then it will not wrap
*/
const reformatOneFourthColumnString = (str) => {
  let newString = str;
  let strLength = newString.length;
  const maxColumnCharacters = 28;

  let spacesToAdd = strLength / maxColumnCharacters;
  let nextSpacePosition = 27;
  for (let i = 0; i < spacesToAdd; i++) {
    newString =
      newString.substring(0, nextSpacePosition) +
      " " +
      newString.substring(nextSpacePosition);
    nextSpacePosition = nextSpacePosition + 28;
  }
  return newString;
};

//const JOB_DETAILS = (order, qbCustomer) => {
const JOB_DETAILS = (order, outTheDoorCost) => {
  const {
    id,
    quoteType,
    vendorProjectName,
    createdAt,
    poNumber,
    gauge,
    color,
    manufacturer,
    company,
    project,
    quoteNotes,
    taxExemptForm,
    type,
    isMaterialSuppliedByCustomer,
    isCustomMaterial,
    customColor,
    customManufacturer,
    customGauge,
  } = order;

  let jobName;
  let customerName;
  let contactName;
  let contactEmail;
  let contactPhone;

  // GUEST VS MOBILE
  jobName = project.name;
  customerName = company.name;
  let requestedBy = order.estimateRequestedBy;
  contactName =
    requestedBy && requestedBy.fullName
      ? requestedBy.fullName
      : company.contactName;
  contactPhone =
    requestedBy && requestedBy.phone ? requestedBy.phone : company.contactPhone;
  contactEmail =
    requestedBy && requestedBy.email ? requestedBy.email : company.contactEmail;

  // Custom Manufacturer vs Regular
  let colorValue;
  let manufacturerValue;
  let gaugeValue;
  if (isCustomMaterial) {
    colorValue = customColor ? customColor : "";
    manufacturerValue = customManufacturer ? customManufacturer : "";
    colorValue = colorValue + " - " + manufacturerValue;
    gaugeValue = customGauge ? customGauge : "";
  } else {
    colorValue = color + " - " + manufacturer;
    manufacturerValue = manufacturer;

    if (gauge < 1) {
      gaugeValue = `${parseFloat(gauge)} in.`;
    } else {
      gaugeValue = `${parseFloat(gauge)} g`;
    }
  }

  // Chop Column String if 29 characters (add space)
  // pdfMake wraps text to next line only if there are spaces. If one word is too long for the column then it will not wrap
  jobName = reformatOneFourthColumnString(jobName);
  customerName = reformatOneFourthColumnString(customerName);
  contactName = reformatOneFourthColumnString(contactName);
  contactPhone = reformatOneFourthColumnString(contactPhone);
  contactEmail = reformatOneFourthColumnString(contactEmail);
  colorValue = reformatOneFourthColumnString(colorValue);
  manufacturerValue = reformatOneFourthColumnString(manufacturerValue);
  gaugeValue = reformatOneFourthColumnString(gaugeValue);

  let totalPackageQuote = [];
  if (quoteType != "Free Text") {
    totalPackageQuote = [
      {
        text: `Total Package Cost: $${Math.round(Number(outTheDoorCost))}`,
        style: ["subheader", { fontSize: 16 }],
        margin: [0, 10, 0, 10],
        alignment: "right",
      },
      ...LINE_BELOW(),
    ];
  }

  return [
    {
      margin: [0, 8, 0, 0],
      text: `INDUSTRY JOB #${id}${
        quoteType == "Preliminary Cut-List"
          ? " - ESTIMATE ONLY NOT FOR PRODUCTION"
          : ""
      }`,
      // text: `JOB #${id}`,
      style: "subheader",
      alignment: "left",
    },
    ...LINE_TOP(),
    {
      layout: "noBorders", // optional
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", "*", "*", "*"],
        body: [
          [
            {
              text: company.isVendorOrSupplier
                ? "VENDOR / SUPPLIER:"
                : "CUSTOMER NAME:",
              style: "detailName",
            },
            { text: "CONTACT NAME:", style: "detailName" },
            { text: "PHONE NUMBER:", style: "detailName" },
            { text: "EMAIL:", style: "detailName" },
          ],
          [
            { text: `${customerName}`, style: "detailValue" },
            {
              text: `${contactName}`,
              style: "detailValue",
            },
            { text: `${contactPhone}`, style: "detailValue" },
            {
              text: `${contactEmail}`,
              style: "detailValue",
            },
          ],
        ],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      layout: "noBorders", // optional
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", "*", "*", "*"],

        body: [
          [
            { text: "DATE:", style: "detailName" },
            { text: "PO #:", style: "detailName" },
            {
              text: company.isVendorOrSupplier ? "CUSTOMER NAME:" : "JOB NAME:",
              style: "detailName",
            },
            {
              text: company.isVendorOrSupplier ? "JOB NAME:" : "",
              style: "detailName",
            },
          ],
          [
            {
              text: `${formatDate(new Date(createdAt))}`,
              style: "detailValue",
            },
            {
              text: `${
                poNumber ? reformatOneFourthColumnString(poNumber) : ""
              }`,
              style: "detailValue",
            },
            { text: `${jobName}`, style: "detailValue" },
            {
              text: `${
                vendorProjectName
                  ? reformatOneFourthColumnString(vendorProjectName)
                  : ""
              }`,
              style: "detailValue",
            },
          ],
        ],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      layout: "noBorders", // optional
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", "*", "*", "*"],

        body: [
          [
            { text: "MATERIAL SOURCE:", style: "detailName" },
            { text: "COLOR:", style: "detailName" },
            { text: "GAUGE:", style: "detailName" },
            { text: "", style: "detailName" },
          ],
          [
            {
              text: isMaterialSuppliedByCustomer
                ? `Customer Supplied`
                : `Supplied by Industry`,
              style: "detailValue",
            },
            { text: `${colorValue}`, style: "detailValue" },
            { text: `${gaugeValue}`, style: "detailValue" },
            { text: ``, style: "detailValue" },
          ],
        ],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
    ...totalPackageQuote,
  ];
};

const SKID_CHARGE = (skidCharge, markUpPercentage) => {
  if (!skidCharge) {
    return [];
  }

  let skidChargeTotal = applyMarkup(skidCharge, markUpPercentage);

  return [
    {
      text: `SKID CHARGE (PALLET CHARGE): $${Math.round(
        parseFloat(skidChargeTotal)
      )}`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
    },
    // {
    //   text: ``,
    //   style: "subheader",
    //   margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    // },
    // ...LINE_BELOW(),
  ];
};

const ACCESSORIES = (
  accessoriesOrderItem,
  outTheDoorCost,
  markUpPercentage
) => {
  if (!accessoriesOrderItem) {
    return [];
  }

  let accessoriesTotalSellPrice = Number(
    accessoriesOrderItem.totalSellPrice ?? 0
  );
  accessoriesTotalSellPrice = applyMarkup(
    accessoriesTotalSellPrice,
    markUpPercentage
  );

  const accessories = [];
  for (let i = 0; i < accessoriesOrderItem.items.length; i++) {
    let item = accessoriesOrderItem.items[i];
    accessories.push([
      { text: `${item.name}`, style: "tableCell" },
      { text: `${item.quantity}`, style: "tableCell" },
      { text: `${item.unitOfMeasure}`, style: "tableCell" },
      {
        text: `$${toTwoDecimals(
          applyMarkup(Number(item.pricePerPiece ?? 0), markUpPercentage)
        )}`,
        style: "tableCell",
      },
      {
        text: `$${toTwoDecimals(
          applyMarkup(Number(item.totalSellPrice ?? 0), markUpPercentage)
        )}`,
        style: "tableCell",
      },
    ]);
  }

  return [
    {
      text: `ACCESSORIES / MISC - Total Cost: $${Math.round(
        parseFloat(accessoriesTotalSellPrice)
      )}`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", 25, 25, 60, 100],

        body: [
          [
            {
              text: "DESCRIPTION",
              style: "tableHeader",
              fillColor: "#D3D3D3",
            },
            { text: "QTY", style: "tableHeader", fillColor: "#D3D3D3" },
            { text: "UOM", style: "tableHeader", fillColor: "#D3D3D3" },
            { text: "PRICE", style: "tableHeader", fillColor: "#D3D3D3" },
            { text: "AMOUNT", style: "tableHeader", fillColor: "#D3D3D3" },
          ],
          ...accessories,
        ],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};

const FLAT_SHEET = (flatSheetItem, outTheDoorCost, markUpPercentage) => {
  if (!flatSheetItem) {
    return [];
  }

  let flatSheetTotalSellPrice = applyMarkup(
    Number(flatSheetItem.totalSellPrice ?? 0),
    markUpPercentage
  );

  return [
    {
      text: `FLAT SHEETS - Total Cost: $${Math.round(
        parseFloat(flatSheetTotalSellPrice)
      )}`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", 80, "*", 120],

        body: [
          [
            {
              text: "WIDTH (IN.)",
              style: "tableHeader",
              fillColor: "#D3D3D3",
            },
            { text: "QTY", style: "tableHeader", fillColor: "#D3D3D3" },
            {
              text: "PRICE PER FLAT SHEET",
              style: "tableHeader",
              fillColor: "#D3D3D3",
            },
            { text: "TOTAL", style: "tableHeader", fillColor: "#D3D3D3" },
          ],
          [
            { text: `${flatSheetItem.width}`, style: "tableCell" },
            { text: `${flatSheetItem.quantity}`, style: "tableCell" },
            {
              //   text: `$${toTwoDecimals(
              //     applyMarkup(
              //       flatSheetItem.flatSheetCalculations.pricePerFlatSheet,
              //       markUpPercentage
              //     )
              //   )}`,
              text: `$${toTwoDecimals(
                applyMarkup(flatSheetItem.pricePerPiece, markUpPercentage)
              )}`,
              style: "tableCell",
            },
            {
              text: `$${toTwoDecimals(
                applyMarkup(
                  Number(flatSheetItem.totalSellPrice ?? 0),
                  markUpPercentage
                )
              )}`,
              style: "tableCell",
            },
          ],
        ],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};

const COIL = (coilItem, outTheDoorCost, markUpPercentage) => {
  if (!coilItem) {
    return [];
  }

  let coilTotalSellPrice = applyMarkup(
    Number(coilItem.totalSellPrice) ?? 0,
    markUpPercentage
  );

  return [
    {
      text: `COIL - Total Cost: $${Math.round(parseFloat(coilTotalSellPrice))}`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", 80, "*", 80, 100],

        body: [
          [
            { text: "WIDTH (IN.)", style: "tableHeader", fillColor: "#D3D3D3" },
            {
              text: "LINEAL FEET OF COIL",
              style: "tableHeader",
              fillColor: "#D3D3D3",
            },
            {
              text: "SQUARE FOOT PRICING",
              style: "tableHeader",
              fillColor: "#D3D3D3",
            },
            {
              text: "LINEAL FOOT PRICING",
              style: "tableHeader",
              fillColor: "#D3D3D3",
            },
            { text: "TOTAL", style: "tableHeader", fillColor: "#D3D3D3" },
          ],
          [
            { text: `${coilItem.width}`, style: "tableCell" },
            { text: `${coilItem.linealFeet}`, style: "tableCell" },
            {
              //   text: `$${toTwoDecimals(
              //     applyMarkup(
              //       coilItem.coilCalculations.pricePerSquareFeetOfCoil,
              //       markUpPercentage
              //     )
              //   )}`,
              text: `$${toTwoDecimals(
                applyMarkup(coilItem.pricePerSquareFeetOfCoil, markUpPercentage)
              )}`,
              style: "tableCell",
            },
            {
              //   text: `$${toTwoDecimals(
              //     applyMarkup(
              //       coilItem.coilCalculations.pricePerLinealFootOfCoil,
              //       markUpPercentage
              //     )
              //   )}`,
              text: `$${toTwoDecimals(
                applyMarkup(coilItem.pricePerLinealFootOfCoil, markUpPercentage)
              )}`,
              style: "tableCell",
            },
            {
              text: `$${toTwoDecimals(
                applyMarkup(coilItem.totalSellPrice ?? 0, markUpPercentage)
              )}`,
              style: "tableCell",
            },
          ],
        ],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};

const PANEL_IMAGE = (panelOrderItem, productImages) => {
  let { Panel } = productImages;
  if (!panelOrderItem || !Panel) return [];
  return [
    // {
    //   text: `${panelOrderItem.panelType} ${panelOrderItem.panelWidth} ${panelOrderItem.panelProfile}`,
    //   style: "subheader",
    //   margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
    // },
    {
      margin: [0, 8, 0, 0],
      image: `Panel`,
      width: 400,
      alignment: "center",
    },
  ];
};

// Ascending Name
const sortPanelCutList = (panelCuts) => {
  panelCuts.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
};

const PANEL = (
  panelOrderItem,
  calculations,
  productImages,
  markUpPercentage
) => {
  // return empty array if panelOrderItem does not exist
  if (!panelOrderItem) return [];

  const panelCuts = [];
  let cutList = panelOrderItem.cuts;
  sortPanelCutList(cutList);

  for (let i = 0; i < cutList.length; i++) {
    let panelCut = cutList[i];
    let panelCutLF = panelCut.feet + panelCut.inches / 12;
    let totalPanelCutLF = panelCutLF * panelCut.quantity;
    panelCuts.push([
      { text: `${panelCut.name}`, style: "tableCell" },
      { text: `${panelCut.quantity}`, style: "tableCell" },
      { text: `${panelCut.feet}`, style: "tableCell" },
      { text: `${panelCut.inches}`, style: "tableCell" },
    ]);
  }

  let panelTotalCost = Math.round(
    parseFloat(
      panelOrderItem && panelOrderItem.totalSellPrice
        ? panelOrderItem.totalSellPrice
        : 0.0
    )
  );
  panelTotalCost = toTwoDecimals(applyMarkup(panelTotalCost, markUpPercentage));

  return [
    {
      text: `PANEL SYSTEM - Total Cost: $${Math.round(panelTotalCost)}`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      layout: "noBorders", // optional
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", "*", "*", 100, "*"],

        body: [
          [
            { text: "SYSTEM:", style: "detailName" },
            { text: "PANEL NAME:", style: "detailName" },
            { text: "PANEL WIDTH:", style: "detailName" },
            // { text: "MASTER COIL WIDTH:", style: "detailName" },
          ],
          [
            { text: `${panelOrderItem.panelSystem}`, style: "detailValue" },

            { text: `${panelOrderItem.panelType}`, style: "detailValue" },
            { text: `${panelOrderItem.panelWidth}`, style: "detailValue" },
            // {
            //   text: `${panelOrderItem.calculations.masterCoilSizeNeeded}`,
            //   style: "detailValue",
            // },
          ],
        ],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    // PANEL_IMAGE(panelOrderItem, productImages),
    // ...LINE_BELOW(),
    {
      layout: "noBorders",
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["*", 100],
        body: [
          [
            ...PANEL_IMAGE(panelOrderItem, productImages),
            [
              {
                text: `Total Panel SF: `,
                width: "*",
                style: ["tableCell", { bold: true }],
                margin: [0, 30, 0, 0],
              },
              {
                text: `${panelOrderItem.calculations.finishedPanelSquareFeet}`,
                width: "*",
                style: ["tableCell"],
              },
              {
                text: `Total Panel LF: `,
                width: "*",
                style: ["tableCell", { bold: true }],
                margin: [0, 30, 0, 0],
              },
              {
                text: `${panelOrderItem.calculations.linealFeetOfCoilNoWaste}`,
                width: "*",
                style: ["tableCell"],
              },
            ],
          ],
        ],
      },
      margin: [0, 0, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: [200, "*", "*", "*"],

        body: [
          [
            {
              text: "PANEL NAME",
              style: "tableHeader",
              fillColor: "#D3D3D3",
            },
            { text: "QTY", style: "tableHeader", fillColor: "#D3D3D3" },
            { text: "FEET", style: "tableHeader", fillColor: "#D3D3D3" },
            { text: "INCHES", style: "tableHeader", fillColor: "#D3D3D3" },
          ],
          ...panelCuts,
        ],
      },
      margin: [0, 8, 0, 0], // margin: [left, top, right, bottom]
    },
  ];
};

const EMPTY_TRIM_IMAGE = () => {
  return [
    {
      margin: [0, 8, 0, 0],
      canvas: [
        {
          type: "rect",
          // x: 0,
          x: 62,
          y: 0,
          // w: 250,
          // h: 250,
          w: 125,
          h: 125,
          lineWidth: 1,
          lineColor: "#000000",
        },
      ],
    },
    {
      text: "    ",
      style: "imageText",
    },
    {
      text: "    ",
      style: "imageText",
    },
  ];
};

const TRIM_AND_FLASHING_SUMMARY = (
  trimOrderItem,
  productImages,
  isItemized,
  markUpPercentage
) => {
  if (!trimOrderItem) return [];

  let trimTotalSellPrice = 0;

  trimTotalSellPrice = applyMarkup(
    Number(trimOrderItem.totalSellPrice ?? 0),
    markUpPercentage
  );

  let trimPieces = [];
  let i;
  for (i = 0; i < trimOrderItem.trimPieces.length; i++) {
    let item = trimOrderItem.trimPieces[i];
    if (isItemized) {
      trimPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
        {
          //   text: `$${toTwoDecimals(
          //     applyMarkup(item.calculations.pricePerPiece, markUpPercentage)
          //   )}`,
          text: `$${toTwoDecimals(
            applyMarkup(item.pricePerPiece, markUpPercentage)
          )}`,
          style: "tableCell",
        },
      ]);
    } else {
      trimPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
      ]);
    }
  }

  let tableHeaders = [
    {
      text: "DESCRIPTION",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    },
    { text: "QTY", style: "tableHeader", fillColor: "#D3D3D3" },
  ];
  let widths = ["*", 60];

  if (isItemized) {
    tableHeaders.push({
      text: "PRICE PER PIECE",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    });
    widths.push(100);
  }
  return [
    {
      text: `TRIM & FLASHING - Total Cost: $${Math.round(
        parseFloat(trimTotalSellPrice)
      )}`,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: `*Detail drawings on back`,
      style: {
        bold: true,
        fontSize: 6,
      },
      margin: [0, 0, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: widths,
        body: [tableHeaders, ...trimPieces],
      },
      margin: [0, 4, 0, 10], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};

const TRIM_AND_FLASHING = (trimOrderItem, productImages, isItemized) => {
  if (!trimOrderItem) return [];
  let pieceIndex = 0;
  let trimPieces = [];
  while (pieceIndex < trimOrderItem.trimPieces.length) {
    let quadrantIterator;
    let cells = [];
    for (quadrantIterator = 0; quadrantIterator < 8; quadrantIterator++) {
      let currentIndex = pieceIndex + quadrantIterator;
      if (currentIndex < trimOrderItem.trimPieces.length) {
        let currentPiece = trimOrderItem.trimPieces[currentIndex];
        let cell = [
          {
            margin: [62, 8, 0, 0],
            table: {
              widths: ["auto"],
              body: [
                [
                  {
                    // margin: [left, top, right, bottom]
                    margin: [0, 1, 0, 1],
                    image: `TrimAndFlashing${currentIndex}`,
                    width: 120,
                    height: 120,
                    alignment: "center",
                  },
                ],
              ],
            },
          },
          {
            margin: [0, 4, 0, 0],
            text: [
              { text: `Piece Name: `, style: "imageText" },
              { text: `${currentPiece.name}`, style: "imageTextBold" },
            ],
            style: "header",
          },
          {
            text: `Qty: ${currentPiece.quantity}`,
            style: "imageText",
          },
        ];
        cells.push(cell);
      } else {
        cells.push(EMPTY_TRIM_IMAGE());
      }
    }
    trimPieces = [
      ...trimPieces,
      OCTANT(
        cells[0],
        cells[1],
        cells[2],
        cells[3],
        cells[4],
        cells[5],
        cells[6],
        cells[7]
      ),
    ];
    pieceIndex += 8;
  }

  return [
    {
      text: `TRIM & FLASHING`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
      pageBreak: "before",
    },
    ...trimPieces,
  ];
};

const COPING_CAP_SUMMARY = (
  copingCapOrderItem,
  productImages,
  isItemized,
  markUpPercentage
) => {
  if (!copingCapOrderItem) return [];

  let trimTotalSellPrice = Number(copingCapOrderItem.totalSellPrice ?? 0);
  trimTotalSellPrice = applyMarkup(trimTotalSellPrice, markUpPercentage);

  let capPieces = [];
  let i;
  for (i = 0; i < copingCapOrderItem.capPieces.length; i++) {
    let item = copingCapOrderItem.capPieces[i];
    if (isItemized) {
      capPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
        {
          //   text: `$${toTwoDecimals(
          //     applyMarkup(item.calculations.pricePerPiece, markUpPercentage)
          //   )}`,
          text: `$${toTwoDecimals(
            applyMarkup(item.pricePerPiece, markUpPercentage)
          )}`,
          style: "tableCell",
        },
      ]);
    } else {
      capPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
      ]);
    }
  }

  let tableHeaders = [
    {
      text: "DESCRIPTION",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    },
    { text: "QTY", style: "tableHeader", fillColor: "#D3D3D3" },
  ];
  let widths = ["*", 60];

  if (isItemized) {
    tableHeaders.push({
      text: "PRICE PER PIECE",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    });
    widths.push(100);
  }
  return [
    {
      text: `COPING CAP - Total Cost $${Math.round(
        parseFloat(trimTotalSellPrice)
      )}`,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: `*Detail drawings on back`,
      style: {
        bold: true,
        fontSize: 6,
      },
      margin: [0, 0, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: widths,
        body: [tableHeaders, ...capPieces],
      },
      margin: [0, 4, 0, 10], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};

const COPING_CAP = (
  copingCapOrderItem,
  productImages,
  isItemized,
  markUpPercentage
) => {
  if (!copingCapOrderItem) return [];

  let trimTotalSellPrice = Number(copingCapOrderItem.totalSellPrice ?? 0);
  trimTotalSellPrice = applyMarkup(trimTotalSellPrice, markUpPercentage);

  let pieceIndex = 0;
  let capPieces = [];
  while (pieceIndex < copingCapOrderItem.capPieces.length) {
    let quadrantIterator;
    let cells = [];
    for (quadrantIterator = 0; quadrantIterator < 8; quadrantIterator++) {
      let currentIndex = pieceIndex + quadrantIterator;
      if (currentIndex < copingCapOrderItem.capPieces.length) {
        let currentPiece = copingCapOrderItem.capPieces[currentIndex];
        let cell = [
          {
            margin: [62, 8, 0, 0],
            table: {
              widths: ["auto"],
              body: [
                [
                  {
                    // margin: [left, top, right, bottom]
                    margin: [0, 1, 0, 1],
                    image: `CopingCap${currentIndex}`,
                    width: 120,
                    height: 120,
                    alignment: "center",
                  },
                ],
              ],
            },
          },
          {
            margin: [0, 4, 0, 0],
            text: [
              { text: `Piece Name: `, style: "imageText" },
              { text: `${currentPiece.name}`, style: "imageTextBold" },
            ],
            style: "header",
          },
          {
            text: `Qty: ${currentPiece.quantity}`,
            style: "imageText",
          },
        ];
        cells.push(cell);
      } else {
        cells.push(EMPTY_TRIM_IMAGE());
      }
    }
    capPieces = [
      ...capPieces,
      OCTANT(
        cells[0],
        cells[1],
        cells[2],
        cells[3],
        cells[4],
        cells[5],
        cells[6],
        cells[7]
      ),
    ];
    pieceIndex += 8;
  }

  return [
    {
      text: `COPING CAP`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
      pageBreak: "before",
    },
    ...capPieces,
  ];
};

const CLEAT_SUMMARY = (
  cleatOrderItem,
  productImages,
  isItemized,
  markUpPercentage
) => {
  if (!cleatOrderItem) return [];

  let trimTotalSellPrice = Number(cleatOrderItem.totalSellPrice ?? 0);
  trimTotalSellPrice = applyMarkup(trimTotalSellPrice, markUpPercentage);

  let cleatPieces = [];
  let i;
  for (i = 0; i < cleatOrderItem.cleatPieces.length; i++) {
    let item = cleatOrderItem.cleatPieces[i];
    if (isItemized) {
      cleatPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
        {
          //   text: `$${toTwoDecimals(
          //     applyMarkup(item.calculations.pricePerPiece, markUpPercentage)
          //   )}`,
          text: `$${toTwoDecimals(
            applyMarkup(item.pricePerPiece, markUpPercentage)
          )}`,
          style: "tableCell",
        },
      ]);
    } else {
      cleatPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
      ]);
    }
  }

  let tableHeaders = [
    {
      text: "DESCRIPTION",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    },
    { text: "QTY", style: "tableHeader", fillColor: "#D3D3D3" },
  ];
  let widths = ["*", 60];

  if (isItemized) {
    tableHeaders.push({
      text: "PRICE PER PIECE",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    });
    widths.push(100);
  }
  return [
    {
      text: `CLEAT - Total Cost $${Math.round(parseFloat(trimTotalSellPrice))}`,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: `*Detail drawings on back`,
      style: {
        bold: true,
        fontSize: 6,
      },
      margin: [0, 0, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: widths,
        body: [tableHeaders, ...cleatPieces],
      },
      margin: [0, 4, 0, 10], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};
const CLEAT = (cleatOrderItem, productImages, isItemized) => {
  if (!cleatOrderItem) return [];

  let pieceIndex = 0;
  let cleatPieces = [];
  while (pieceIndex < cleatOrderItem.cleatPieces.length) {
    let quadrantIterator;
    let cells = [];
    for (quadrantIterator = 0; quadrantIterator < 8; quadrantIterator++) {
      let currentIndex = pieceIndex + quadrantIterator;
      if (currentIndex < cleatOrderItem.cleatPieces.length) {
        let currentPiece = cleatOrderItem.cleatPieces[currentIndex];
        let cell = [
          {
            margin: [62, 8, 0, 0],
            table: {
              widths: ["auto"],
              body: [
                [
                  {
                    // margin: [left, top, right, bottom]
                    margin: [0, 1, 0, 1],
                    image: `CopingCapCleat${currentIndex}`,
                    width: 120,
                    height: 120,
                    alignment: "center",
                  },
                ],
              ],
            },
          },
          {
            margin: [0, 4, 0, 0],
            text: [
              { text: `Piece Name: `, style: "imageText" },
              { text: `${currentPiece.name}`, style: "imageTextBold" },
            ],
            style: "header",
          },
          {
            text: `Qty: ${currentPiece.quantity}`,
            style: "imageText",
          },
        ];
        cells.push(cell);
      } else {
        cells.push(EMPTY_TRIM_IMAGE());
      }
    }
    cleatPieces = [
      ...cleatPieces,
      OCTANT(
        cells[0],
        cells[1],
        cells[2],
        cells[3],
        cells[4],
        cells[5],
        cells[6],
        cells[7]
      ),
    ];
    pieceIndex += 8;
  }

  return [
    {
      text: `CLEAT`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
      pageBreak: "before",
    },
    ...cleatPieces,
  ];
};

const BENCH_WORK_SUMMARY = (
  benchWorkOrderItem,
  productImages,
  isItemized,
  markUpPercentage
) => {
  if (!benchWorkOrderItem) return [];

  let trimTotalSellPrice = Number(benchWorkOrderItem.totalSellPrice ?? 0);
  trimTotalSellPrice = applyMarkup(trimTotalSellPrice, markUpPercentage);

  let benchWorkPieces = [];
  let i;
  for (i = 0; i < benchWorkOrderItem.benchWorkPieces.length; i++) {
    let item = benchWorkOrderItem.benchWorkPieces[i];
    if (isItemized) {
      benchWorkPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
        {
          //   text: `$${toTwoDecimals(
          //     applyMarkup(item.calculations.pricePerPiece, markUpPercentage)
          //   )}`,
          text: `$${toTwoDecimals(
            applyMarkup(item.pricePerPiece, markUpPercentage)
          )}`,
          style: "tableCell",
        },
      ]);
    } else {
      benchWorkPieces.push([
        { text: `${item.name}`, style: "tableCell" },
        { text: `${item.quantity}`, style: "tableCell" },
      ]);
    }
  }

  let tableHeaders = [
    {
      text: "DESCRIPTION",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    },
    { text: "QTY", style: "tableHeader", fillColor: "#D3D3D3" },
  ];
  let widths = ["*", 60];

  if (isItemized) {
    tableHeaders.push({
      text: "PRICE PER PIECE",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    });
    widths.push(100);
  }
  return [
    {
      text: `BENCH WORK - Total Cost $${Math.round(
        parseFloat(trimTotalSellPrice)
      )}`,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: `*Detail drawings on back`,
      style: {
        bold: true,
        fontSize: 6,
      },
      margin: [0, 0, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      unbreakable: true,
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: widths,
        body: [tableHeaders, ...benchWorkPieces],
      },
      margin: [0, 4, 0, 10], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};
const BENCH_WORK = (benchWorkOrderItem, productImages, isItemized) => {
  if (!benchWorkOrderItem) return [];

  let trimTotalSellPrice = 0;
  for (const piece of benchWorkOrderItem.benchWorkPieces) {
    if (piece.calculations && piece.totalSellPrice)
      trimTotalSellPrice += Number(piece.totalSellPrice ?? 0);
  }

  let pieceIndex = 0;
  let benchWorkPieces = [];
  while (pieceIndex < benchWorkOrderItem.benchWorkPieces.length) {
    let quadrantIterator;
    let cells = [];
    for (quadrantIterator = 0; quadrantIterator < 8; quadrantIterator++) {
      let currentIndex = pieceIndex + quadrantIterator;
      if (currentIndex < benchWorkOrderItem.benchWorkPieces.length) {
        let currentPiece = benchWorkOrderItem.benchWorkPieces[currentIndex];
        let cell = [
          {
            margin: [62, 8, 0, 0],
            table: {
              widths: ["auto"],
              body: [
                [
                  {
                    // margin: [left, top, right, bottom]
                    margin: [0, 1, 0, 1],
                    image: `BenchWork${currentIndex}`,
                    width: 120,
                    height: 120,
                    alignment: "center",
                  },
                ],
              ],
            },
          },
          {
            margin: [0, 4, 0, 0],
            text: [
              { text: `Piece Name: `, style: "imageText" },
              {
                text: `${currentPiece.name}`,
                style: "imageTextBold",
              },
            ],
            style: "header",
          },
          {
            text: `Qty: ${currentPiece.quantity}`,
            style: "imageText",
          },
        ];
        cells.push(cell);
      } else {
        cells.push(EMPTY_TRIM_IMAGE());
      }
    }
    benchWorkPieces = [
      ...benchWorkPieces,
      OCTANT(
        cells[0],
        cells[1],
        cells[2],
        cells[3],
        cells[4],
        cells[5],
        cells[6],
        cells[7]
      ),
    ];
    pieceIndex += 8;
  }

  return [
    {
      text: `BENCH WORK`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
      pageBreak: "before",
    },
    ...benchWorkPieces,
  ];
};
const SPLICE_PLATES = (splicePlatesOrderItem, isItemized, markUpPercentage) => {
  if (!splicePlatesOrderItem) return [];

  let trimTotalSellPrice = Number(splicePlatesOrderItem.totalSellPrice ?? 0);
  trimTotalSellPrice = applyMarkup(trimTotalSellPrice, markUpPercentage);

  const plates = [];
  let total = 0;
  for (let i = 0; i < splicePlatesOrderItem.plates.length; i++) {
    let plate = splicePlatesOrderItem.plates[i];

    total += plate.quantity;

    if (isItemized) {
      plates.push([
        { text: `${plate.quantity}`, style: "tableCell" },
        { text: `${plate.length}"`, style: "tableCell" },
        {
          //   text: `$${toTwoDecimals(
          //     applyMarkup(plate.calculations.pricePerPiece, markUpPercentage)
          //   )}`,
          text: `$${toTwoDecimals(
            applyMarkup(plate.pricePerPiece, markUpPercentage)
          )}`,
          style: "tableCell",
        },
      ]);
    } else {
      plates.push([
        { text: `${plate.quantity}`, style: "tableCell" },
        { text: `${plate.length}"`, style: "tableCell" },
      ]);
    }
  }

  let tableWidths = isItemized ? ["*", "*", "*"] : ["*", "*"];
  let tableHeaders = [
    {
      text: "QTY (pc)",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    },
    {
      text: "PIECE LENGTH",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    },
  ];
  if (isItemized)
    tableHeaders.push({
      text: "PRICE PER PIECE",
      style: "tableHeader",
      fillColor: "#D3D3D3",
    });
  return [
    {
      text: `SPLICE PLATES - Total Cost: $${Math.round(
        parseFloat(trimTotalSellPrice)
      )}`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
      pageBreak: "before",
    },
    {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: tableWidths,
        body: [tableHeaders, ...plates],
      },
      margin: [0, 4, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: ``,
      style: "subheader",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
    ...LINE_BELOW(),
  ];
};

const TWO_COLUMNS = (contents1, contents2) => {
  return [
    {
      columnGap: COLUMN_GAP,
      columns: [
        {
          width: HALF_COLUMN_WITH_GAP,
          stack: [[...contents1]],
        },
        {
          width: HALF_COLUMN_WITH_GAP,
          stack: [[...contents2]],
        },
      ],
    },
  ];
};

const END = (order) => {
  const { id, outTheDoorCost } = order;

  return [
    ...TWO_COLUMNS(
      [
        {
          text: `TOTAL: $${outTheDoorCost}`,
          style: "subheader",
          alignment: "left",
        },
      ],
      [
        {
          margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
          unbreakable: true,
          stack: [
            [
              {
                text: "WORK ORDER NOTES",
                style: "subheader",
              },
            ],
            [
              {
                text: `${order.quoteNotes || ""}`,
                fontSize: 10,
              },
            ],
          ],
        },
      ]
    ),
  ];
};

const FREE_TEXT_QUOTE_SUMMARY = (quoteNotes) => {
  return [
    {
      text: `Quote Summary`,
      style: "subheader",
      margin: [0, SECTION_MARGIN, 0, 0], // margin: [left, top, right, bottom]
    },
    {
      text: quoteNotes ?? "",
      style: "detailValue",
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
    },
  ];
};

const SIGNATURE_V1 = (
  outTheDoorCost,
  signatureBase64,
  signeeFullName,
  isSalesTaxApplicable,
  addPageBreak
) => {
  return [
    {
      pageBreak: addPageBreak ? "before" : null,
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
      unbreakable: true,
      stack: [
        {
          columnGap: 4,
          columns: [
            {
              image: isSalesTaxApplicable ? "checked" : "unchecked",
              width: 10,
            },
            {
              text: "Is Sales Tax Applicable to this Order?  ",
              style: "subheader",
              width: "*",
            },
          ],
        },

        // [{ text: "[   ]Y [   ]N", style: { bold: false } }],
        [
          {
            margin: [0, 4, 0, 0],
            text: `If applicable, the Sales Tax will appear on your invoice, and is not included in this quote.`,
            fontSize: 10,
          },
        ],
      ],
    },
    {
      margin: [0, 30, 0, 0], // margin: [left, top, right, bottom]
      unbreakable: true,
      stack: [
        [
          {
            text: [
              {
                text: "Print Name: ",
                bold: true,
                fontSize: 12,
              },
              {
                text: signeeFullName
                  ? `${signeeFullName}                              `
                  : "                                                                    ",
                fontSize: 12,
                decoration: "underline",
              },
            ],
          },
        ],
      ],
    },
    {
      margin: [0, 25, 0, 0],
      layout: "lightHorizontalLines", // optional
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: ["auto", "auto"],
        body: [
          [
            {
              text: "Signature: ",
              bold: true,
              fontSize: 12,
              alignment: "left",
            },
            signatureBase64
              ? {
                  table: {
                    widths: ["*"],
                    body: [
                      [
                        {
                          margin: [0, 8, 0, 0],
                          image: `Signature`,
                          alignment: "left",
                          // fit: [200, 620],
                        },
                      ],
                    ],
                  },
                }
              : {
                  text: `_________________________________________`,
                  bold: true,
                  fontSize: 12,
                  alignment: "left",
                },
          ],
        ],
      },
    },
    [
      {
        // to treat a paragraph as a bulleted list, set an array of items under the ul key
        margin: [0, 8, 0, 0],
        ul: [
          {
            text: "This quote is hereby accepted by customer and authorized for fabrication. This quote is valid for 30 days. All orders must be pre-paid in full prior to fabrication via check or credit card. Industry Metal Co does not offer credit terms at this time. ",
            fontSize: 8,
          },
          {
            text: "This Quote does not include Sales Tax or Credit Card Convenience Fee. Our Credit Card Fee is 2.5%. For Sales Tax please indicate if this is a taxable sale or not. If not taxable, we must have a current AZ5005 on file. ",
            fontSize: 8,
          },
          {
            text: "If we are delivering your material, it shall be up to you to have sufficient manpower and/or equipment on-site at the time of our delivery to offload. Our delivery service does not include off-loading from our truck. Our driver will help where he can, but his assistance is not guaranteed. A typical truckload should take no more than 30 minutes to unload, and anything in excess to this allotted time frame will be charged at a rate of $40 per every 15 minutes, and charged to the credit card used to place the order, or to the credit account. If nobody is onsite, and we need to schedule a re-delivery, there will be an additional charge ",
            fontSize: 8,
          },
          {
            text: "Minor scratches, chips, scrapes, dings, etc are inevitable during the fabrication and packaging process and are not a cause for rejection. ",
            fontSize: 8,
          },
          {
            text: `We do not allow CMG flat sheets to be drop-shipped and "toll-formed", all CMG material must be supplied by Industry Metal Co, unless specifically noted in the quote and or other written agreement between Industry Metal Co and Customer. All manufacturers (other than CMG) can be drop shipped and you will be charged for fabrication only.`,
            fontSize: 8,
          },
          {
            text: "We are not responsible for extra material, or shorted material - Flat Sheets and/or Coil, on customer supplied material.",
            fontSize: 8,
          },
          {
            text: "Flat Sheets stored over 30 days shall become the property of Industry Metal Co, unless another agreement is in place. (Only written agreements shall be valid).",
            fontSize: 8,
          },
          {
            text: "We attempt to optimize all cuts to get the most product out of one flat sheet, however, we cannot guarantee perfect optimization.",
            fontSize: 8,
          },
          {
            text: `When Flat Sheets are included in your trim / flashing pricing, we figure out how many flat sheets are needed for each piece of trim, and then you are charged for those flat sheets. For example, if you order (2) 6" stretch out pieces, you are still charged for the entire 48" flat sheet. Basically, we do not calculate utilizing the "drop" for other pieces in your order, nor do we provide you with the extra drop, therefore it is best for you to utilize entire sheets for each detail. The "drop" becomes property of Industry Metal Co.`,
            fontSize: 8,
          },
          {
            text: `Packages are billed upon contract acceptance, and the order will not be processed until paid for in full. All orders are "custom" and once we process material for your order, we typically cannot use for another order.`,
            fontSize: 8,
          },
          {
            text: `We are not liable for finished orders left over (30) days. We shall not be liable for material shortages / overages for quantities provided to you. For example, if you give us an order, and we tell you that you need 10 flat sheets but you need 12 (or vice-versa), we shall not be held liable for the extra or the shortage.`,
            fontSize: 8,
          },
          {
            text: `All hems are .5" and "open" unless noted otherwise.`,
            fontSize: 8,
          },
          {
            text: `All angles are 45deg or 90deg unless noted otherwise.`,
            fontSize: 8,
          },
          {
            text: `Industry Metal Co is not liable for pieces made with the color facing the wrong direction if the color direction is not clearly marked on the detail.`,
            fontSize: 8,
          },
          {
            text: `Delivery is not included unless specifically noted in contract.`,
            fontSize: 8,
          },
          {
            text: `Crating and Packaging shall be an Additional Charge, and is itemized in the contract`,
            fontSize: 8,
          },
          {
            text: `Implied Warranty: the warranty of our products is restricted to the paint finish only, and Industry Metal Co does not express or imply any type of warranty related to waterproofing, product performance, etc.`,
            fontSize: 8,
          },
        ],
      },
    ],
  ];
};

const SIGNATURE_V2 = (
  estimateApprovalDate,
  signeeFullName,
  signeeEmail,
  estimateApprovalSealId,
  isSalesTaxApplicable,
  addPageBreak
) => {
  return [
    {
      pageBreak: addPageBreak ? "before" : null,
      margin: [0, 10, 0, 0], // margin: [left, top, right, bottom]
      unbreakable: true,
      stack: [
        {
          columnGap: 4,
          columns: [
            {
              image: isSalesTaxApplicable ? "checked" : "unchecked",
              width: 10,
            },
            {
              text: "Is Sales Tax Applicable to this Order?  ",
              style: "subheader",
              width: "*",
            },
          ],
        },

        // [{ text: "[   ]Y [   ]N", style: { bold: false } }],
        [
          {
            margin: [0, 4, 0, 0],
            text: `If applicable, the Sales Tax will appear on your invoice, and is not included in this quote.`,
            fontSize: 10,
          },
        ],
      ],
    },
    {
      margin: [0, 20, 0, 0], // margin: [left, top, right, bottom]
      unbreakable: true,
      stack: [
        [
          {
            columns: [
              {
                width: "70%",
                stack: [
                  {
                    margin: [0, 8, 0, 0], // margin: [left, top, right, bottom]
                    unbreakable: true,
                    stack: [
                      [
                        {
                          text: [
                            {
                              text: "Approved By: ",
                              bold: true,
                              fontSize: 12,
                            },
                            {
                              text: signeeFullName
                                ? `${signeeFullName}                              `
                                : "                                                                    ",
                              fontSize: 12,
                              decoration: signeeFullName ? null : "underline",
                            },
                          ],
                        },
                      ],
                    ],
                  },
                  {
                    margin: [0, 8, 0, 0], // margin: [left, top, right, bottom]
                    unbreakable: true,
                    stack: [
                      [
                        {
                          text: [
                            {
                              text: "Signature: ",
                              bold: true,
                              fontSize: 12,
                            },
                            {
                              text: signeeFullName
                                ? `${signeeFullName}                              `
                                : "                                                                                 ",
                              fontSize: 12,
                              font: "AlexBrush",
                              decoration: signeeEmail ? null : "underline",
                            },
                          ],
                        },
                      ],
                    ],
                  },
                  {
                    margin: [0, 8, 0, 0], // margin: [left, top, right, bottom]
                    unbreakable: true,
                    stack: [
                      [
                        {
                          text: [
                            {
                              text: "Email: ",
                              bold: true,
                              fontSize: 12,
                            },
                            {
                              text: signeeEmail
                                ? `${signeeEmail}                              `
                                : "                                                                                 ",
                              fontSize: 12,
                              decoration: signeeEmail ? null : "underline",
                            },
                          ],
                        },
                      ],
                    ],
                  },
                  {
                    margin: [0, 8, 0, 20], // margin: [left, top, right, bottom]
                    unbreakable: true,
                    stack: [
                      [
                        {
                          text: [
                            {
                              text: "Approved On: ",
                              bold: true,
                              fontSize: 12,
                            },
                            {
                              text: estimateApprovalDate
                                ? `${moment(estimateApprovalDate).format(
                                    "MM-DD-YY"
                                  )}                              `
                                : "                                                                    ",
                              fontSize: 12,
                              decoration: estimateApprovalDate
                                ? null
                                : "underline",
                            },
                          ],
                        },
                      ],
                    ],
                  },
                ],
              },
              signeeFullName
                ? {
                    width: "30%",
                    margin: [20, 0, 0, 0], // margin: [left, top, right, bottom]
                    stack: [
                      {
                        text: "Signature Verified",
                        fontSize: 8,
                      },
                      {
                        margin: [0, 4, 0, 4], // margin: [left, top, right, bottom]
                        image: "verified",
                        width: 30,
                      },
                      {
                        text: signeeFullName,
                        fontSize: 8,
                      },
                      {
                        text: moment(estimateApprovalDate).format(
                          "MM.DD.YY h:mm:ss a"
                        ),
                        fontSize: 8,
                      },
                      {
                        text: `ID: ${estimateApprovalSealId}`,
                        fontSize: 8,
                      },
                    ],
                  }
                : null,
            ],
            columnGap: 50,
          },
        ],
      ],
    },

    [
      {
        // to treat a paragraph as a bulleted list, set an array of items under the ul key
        margin: [0, 8, 0, 0],
        ul: [
          {
            text: "All Order Confirmations are valid for 10 days only.",
            fontSize: 8,
            bold: true,
          },
          {
            text: [
              { text: "Payment: ", fontSize: 8, bold: true },
              "All orders must be pre-paid in full prior to fabrication via check or credit card unless your company is currently setup with payment terms, and account must be be current",
            ],
            fontSize: 8,
          },
          {
            text: [
              {
                text: "Credit Card Convenience Fee: ",
                fontSize: 8,
                bold: true,
              },
              "If paying with Credit Card, we will charge a convenience fee of 2.5%. Packages are billed upon contract acceptance, and the order will not be processed until paid for in full ",
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Sales Tax: ", fontSize: 8, bold: true },
              "For Sales Tax please indicate if this is a taxable sale or not. If not taxable, we must have a current AZ5005 on file. This Quote does not include Sales Tax",
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Delivery: ", fontSize: 8, bold: true },
              "Delivery is not included unless specifically noted in the quote. If we are delivering your material, it shall be up to you to have sufficient manpower and/or equipment on-site at the time of our delivery to offload. Our delivery service does not include off-loading from our truck. Our driver will help where he can, but his assistance is not guaranteed. A typical truckload should take no more than 30 minutes to unload, and anything in excess to this allotted time frame will be charged at a rate of $40 per every 15 minutes, and charged to the credit card used to place the order, or to the credit account. If nobody is onsite, and we need to schedule a re-delivery, there will be an additional charge",
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Minor Scratches: ", fontSize: 8, bold: true },
              "Minor scratches, chips, scrapes, dings, etc are inevitable during the fabrication and packaging process and are not a cause for rejection.",
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Toll Forming: ", fontSize: 8, bold: true },
              `If material is provided by customer (“Toll-Forming"), all material amounts will be established by Industry and sent to the customer upon order acceptance. Furthermore, that exact amount of material (coil or flats) is what shall be required and delivered to Industry, at the customer's expense. If Industry receives material for a tollform order and the quantity is less than (or more than) the quantity established / required by Industry, then we will reject the material in full, and it shall be up to the customer to pick up the material, and during that time Industry is not reliable for the material. Once the order is produced, if we are short material (based on our required material amounts), it shall be our responsibility to source and purchase the excess material needed. If there is excess material, we will package the extra material with the finished package, and it shall not constitute any type of credit from Industry. Additionally, Industry will not store extra material for future usage. If there is damaged raw material that is discovered during our fabrication process, we will notify the customer immediately and it is their responsibility to source (and pay for) the extra material needed to complete the order.`,
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Material Storage: ", fontSize: 8, bold: true },
              `Industry Metal Co is not a storage facility, and unless another agreement is in place, we do not store customer material for future fabrication. All toll-forming material to be dropped on a “per-package” / as-needed basis
            Finished packages left over (15) days may be moved outside, and Industry Metal Co shall not be liable for any damage and/or weathering that may occur
            Finished packages left over (30) will be discarded, unless a written agreement is in place to hold for longer than 30 days 
            Flat Sheets stored over 30 days shall become the property of Industry Metal Co, unless another agreement is in place. (Only written agreements shall be valid).`,
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Fabrication: ", fontSize: 8, bold: true },
              `All hems are .5" and "open" unless noted otherwise. 
            All angles are 45deg or 90deg unless noted otherwise. 
            Industry Metal Co is not liable for pieces made with the color facing the wrong direction if the color direction is not clearly marked on the detail.`,
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Details / Design: ", fontSize: 8, bold: true },
              `All fabrication suggestions are suggestions only, and Industry Metal Co shall not be liable for details that do work and/or fit. It shall be up to the customer to verify that the detail is correct, regardless of whether we provided the detail. 
            None of our published / custom details have testing validation - ie: wind, water, and rain. `,
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Crating and Packaging ", fontSize: 8, bold: true },
              `shall be an Additional Charge, and is itemized in the contract`,
            ],
            fontSize: 8,
          },
          {
            text: [
              { text: "Implied Warranty: ", fontSize: 8, bold: true },
              `The warranty of our products is limited / restricted to the paint`,
            ],
            fontSize: 8,
          },
        ],
      },
    ],
  ];
};

// NEED TO ADD CACHE BUST TO PREVENT CACHE IMAGE CORS ERROR
// TODO: https://github.com/bpampuch/pdfmake/issues/2416#issuecomment-1291687790
// Instead of Creating a Presigned URL, create aan api call that directly returns the blob or base64
const getBase64FromUrl = async (url) => {
  let fetchResponse = await fetch(url);
  let blob = await fetchResponse.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onerror = (error) => {
      console.log("FAILED CONVERTED BLOB TO BASE64");
      reject(error);
    };
    reader.onloadend = () => {
      const base64data = reader.result;
      console.log("SUCCESSFULLY CONVERTED BLOB TO BASE64");
      resolve(base64data);
    };
  });
};

const getProductImages = async (order, authToken, isNoAuth, accessToken) => {
  // Put order items in a map by type
  const productMap = new Map();
  for (let i = 0; i < order.items.length; i++) {
    let orderItem = order.items[i];
    productMap.set(`${orderItem.objectType}`, orderItem);
  }
  // Parse Order Items for Images
  let productImages = {};

  let panelProduct = productMap.get("Panel");
  if (panelProduct) {
    switch (panelProduct.panelType) {
      case "SL-175, Beads No Clip Relief":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+12+BEADS+NO+CLIP+RELIEF.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+16+BEADS+NO+CLIP+RELIEF.JPG"
            );
            break;
          case 18:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+18+BEADS+NO+CLIP+RELIEF.JPG"
            );
            break;
        }
        break;
      case "SL-175, Beads With Clip Relief":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+12+BEADS+WITH+CLIP+RELIEF.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+16+BEADS+WITH+CLIP+RELIEF.JPG"
            );
            break;
          case 18:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+18+BEADS+WITH+CLIP+RELIEF.JPG"
            );
            break;
        }
        break;
      case "SL-175, Smooth No Clip Relief":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+12+SMOOTH+NO+CLIP+RELIEF.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+16+SMOOTH+NO+CLIP+RELIEF.JPG"
            );
            break;
          case 18:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+18+SMOOTH+NO+CLIP+RELIEF.JPG"
            );
            break;
        }
        break;
      case "SL-175, Smooth With Clip Relief":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+12+SMOOTH+WITH+CLIP+RELIEF.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+16+SMOOTH+WITH+CLIP+RELIEF.JPG"
            );
            break;
          case 18:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+18+SMOOTH+WITH+CLIP+RELIEF.JPG"
            );
            break;
        }
        break;
      case "SL-175, Striated No Clip Relief":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+12+STRIATED+NO+CLIP+RELIEF.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+16+STRIATED+NO+CLIP+RELIEF.JPG"
            );
            break;
          case 18:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+18+STRIATED+NO+CLIP+RELIEF.JPG"
            );
            break;
        }
        break;
      case "SL-175, Striated With Clip Relief":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+12+STRIATED+WITH+CLIP+RELIEF.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+16+STRIATED+WITH+CLIP+RELIEF.JPG"
            );
            break;
          case 18:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/SL175+18+STRIATED+WITH+CLIP+RELIEF.JPG"
            );
            break;
        }
        break;
      case "NS-10, Smooth":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+12+SMOOTH.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+16+SMOOTH.JPG"
            );
            break;
          // case 18:
          //   // TODO: this image is wrong. No available image for 18 and 20
          //   productImages[`Panel`] = await getBase64FromUrl(
          //     "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+16+SMOOTH.JPG"
          //   );
          //   break;
          // case 20:
          //   // TODO: this image is wrong. No available image for 18 and 20
          //   productImages[`Panel`] = await getBase64FromUrl(
          //     "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+16+SMOOTH.JPG"
          //   );
          //   break;
        }
        break;
      case "NS-10, Striated":
        switch (panelProduct.panelWidth) {
          case 12:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+12+STRIATED.JPG"
            );
            break;
          case 16:
            productImages[`Panel`] = await getBase64FromUrl(
              "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+16+STRIATED.JPG"
            );
            break;
          // case 18:
          //   // TODO: this image is wrong. No available image for 18 and 20
          //   productImages[`Panel`] = await getBase64FromUrl(
          //     "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+16+STRIATED.JPG"
          //   );
          //   break;
          // case 20:
          //   // TODO: this image is wrong. No available image for 18 and 20
          //   productImages[`Panel`] = await getBase64FromUrl(
          //     "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS-10+16+STRIATED.JPG"
          //   );
          //   break;
        }
        break;
      case "MS200, Smooth With Clip Relief":
        productImages[`Panel`] = await getBase64FromUrl(
          "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/MS200.jpg"
        );
        break;
      case "MS200, Striated With Clip Relief":
        productImages[`Panel`] = await getBase64FromUrl(
          "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/MS200.jpg"
        );
        break;
      case "MS200, Stiffening Ribs With Clip Relief":
        productImages[`Panel`] = await getBase64FromUrl(
          "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/MS200.jpg"
        );
        break;
      case "NS-15, Smooth":
        productImages[`Panel`] = await getBase64FromUrl(
          "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS15.jpg"
        );
        break;
      case "NS-15, Striated":
        productImages[`Panel`] = await getBase64FromUrl(
          "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/NS15.jpg"
        );
        break;
      case `Flush Wall - 12\" No Reveal`:
        switch (panelProduct.panelProfile) {
          case "Smooth":
            switch (panelProduct.panelWidth) {
              case 12:
                productImages[`Panel`] = await getBase64FromUrl(
                  "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+12+-+No+Reveal.JPG"
                );
                break;
            }
            break;
        }
        break;
      case `Flush Wall - 12\" + 1\" Reveal`:
        switch (panelProduct.panelProfile) {
          case "Smooth":
            switch (panelProduct.panelWidth) {
              case 13:
                productImages[`Panel`] = await getBase64FromUrl(
                  "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+with+Reveal+12+%2B+1.JPG"
                );
                break;
            }
            break;
        }
        break;
      case `Flush Wall - 12\" + 2\" Reveal`:
        switch (panelProduct.panelProfile) {
          case "Smooth":
            switch (panelProduct.panelWidth) {
              case 14:
                productImages[`Panel`] = await getBase64FromUrl(
                  "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+with+Reveal+12+%2B+2.JPG"
                );
                break;
            }
            break;
        }
        break;
      case `Flush Wall - 12\" + 3\" Reveal`:
        switch (panelProduct.panelProfile) {
          case "Smooth":
            switch (panelProduct.panelWidth) {
              case 15:
                productImages[`Panel`] = await getBase64FromUrl(
                  "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+with+Reveal+12+%2B+3.JPG"
                );
                break;
            }
            break;
        }
        break;
      case "Standard":
        switch (panelProduct.panelWidth) {
          case 16:
            if (panelProduct.panelSystem == "Wave Panel") {
              // Wave Panel
              productImages[`Panel`] = await getBase64FromUrl(
                "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/WAVE_PANEL_16.jpg"
              );
            }
            break;
          case 36:
            if (panelProduct.panelSystem == "AG Panel") {
              // AG Panel
              productImages[`Panel`] = await getBase64FromUrl(
                "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/AG+PANEL+STANDARD.jpg"
              );
            } else {
              // 7.2
              productImages[`Panel`] = await getBase64FromUrl(
                "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/7_2+Panel+Profile.jpg"
              );
            }
            break;
          case 39: // 7/8 Corrugated
            if (panelProduct.panelSystem == "7/8 Corrugated") {
              productImages[`Panel`] = await getBase64FromUrl(
                "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/7_8+Panel+Profile.jpg"
              );
            }
            if (panelProduct.panelSystem == "R-Panel") {
              productImages[`Panel`] = await getBase64FromUrl(
                "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/R_PANEL_36_STANDARD.jpg"
              );
            }
            break;
        }
        break;
      default:
        if (panelProduct.panelType.includes("Flush Wall")) {
          if (panelProduct.panelType.includes("No Reveal")) {
            switch (panelProduct.panelProfile) {
              case "Smooth":
                switch (panelProduct.panelWidth) {
                  case 12:
                    productImages[`Panel`] = await getBase64FromUrl(
                      "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+12+-+No+Reveal.JPG"
                    );
                    break;
                }
                break;
            }
          }
          if (panelProduct.panelType.includes("+ 1")) {
            switch (panelProduct.panelProfile) {
              case "Smooth":
                switch (panelProduct.panelWidth) {
                  case 13:
                    productImages[`Panel`] = await getBase64FromUrl(
                      "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+with+Reveal+12+%2B+1.JPG"
                    );
                    break;
                }
                break;
            }
          } else if (panelProduct.panelType.includes("+ 2")) {
            switch (panelProduct.panelProfile) {
              case "Smooth":
                switch (panelProduct.panelWidth) {
                  case 14:
                    productImages[`Panel`] = await getBase64FromUrl(
                      "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+with+Reveal+12+%2B+2.JPG"
                    );
                    break;
                }
                break;
            }
          } else if (panelProduct.panelType.includes("+ 3")) {
            switch (panelProduct.panelProfile) {
              case "Smooth":
                switch (panelProduct.panelWidth) {
                  case 15:
                    productImages[`Panel`] = await getBase64FromUrl(
                      "https://ezorder-public.s3.us-east-2.amazonaws.com/panel-types/Flush+Wall+with+Reveal+12+%2B+3.JPG"
                    );
                    break;
                }
                break;
            }
          }
        } else {
          // NONE OF THE IMAGES APPLIED
        }
        break;
    }
  }

  // TrimAndFlashing
  let trimAndFlashingProduct = productMap.get("TrimAndFlashing");
  if (trimAndFlashingProduct) {
    let index = 0;
    for (const trimPiece of trimAndFlashingProduct.trimPieces) {
      let base64 = await getBase64FromS3Key(
        trimPiece.image,
        authToken,
        isNoAuth,
        accessToken
      );
      //   productImages[`TrimAndFlashing${index}`] =
      //     "data:image/png;base64," + base64;
      productImages[`TrimAndFlashing${index}`] = base64;
      index++;
    }
  }

  // CopingCap
  let copingCapProduct = productMap.get("CopingCap");
  if (copingCapProduct) {
    let index = 0;
    for (const capPiece of copingCapProduct.capPieces) {
      let base64 = await getBase64FromS3Key(
        capPiece.image,
        authToken,
        isNoAuth,
        accessToken
      );
      //   productImages[`CopingCap${index}`] = "data:image/png;base64," + base64;
      productImages[`CopingCap${index}`] = base64;
      index++;
    }
  }

  // CopingCapCleat
  let copingCapCleatProduct = productMap.get("CopingCapCleat");
  if (copingCapCleatProduct) {
    let index = 0;
    for (const cleatPiece of copingCapCleatProduct.cleatPieces) {
      let base64 = await getBase64FromS3Key(
        cleatPiece.image,
        authToken,
        isNoAuth,
        accessToken
      );
      //   productImages[`CopingCapCleat${index}`] =
      //     "data:image/png;base64," + base64;
      productImages[`CopingCapCleat${index}`] = base64;
      index++;
    }
  }

  // BenchWork
  let benchWorkProduct = productMap.get("BenchWork");
  if (benchWorkProduct) {
    let index = 0;
    for (const benchWorkPiece of benchWorkProduct.benchWorkPieces) {
      let base64 = await getBase64FromS3Key(
        benchWorkPiece.image,
        authToken,
        isNoAuth,
        accessToken
      );
      //   productImages[`BenchWork${index}`] = "data:image/png;base64," + base64;
      productImages[`BenchWork${index}`] = base64;
      index++;
    }
  }

  return productImages;
};

const getVendorLogo = async (order, authToken, isNoAuth, accessToken) => {
  if (!order.company.logo) return null;

  console.log("GET VENDOR LOGO", order.company.logo);
  let base64 = await getBase64FromS3Key(
    order.company.logo,
    authToken,
    isNoAuth,
    accessToken
  );
  console.log("VENDOR LOGO BASE64::: ", base64);
  //   return "data:image/png;base64," + base64;
  return base64;
};

function getImageDimensions(file) {
  return new Promise(function (resolved, rejected) {
    var i = new Image();
    i.onload = function () {
      resolved({ w: i.width, h: i.height });
    };
    i.src = file;
  });
}

// IN THE BACKEND VERSION IT IS "getFileFromS3ByKey" from fileservice
const getBase64FromS3Key = async (s3Key, authToken, isNoAuth, accessToken) => {
  try {
    console.log("getBase64FromS3Key", {
      s3Key,
      authToken,
      isNoAuth,
      accessToken,
    });
    let keySplit = s3Key.split("/");
    let identifier = keySplit[0];
    let resource = keySplit[1];
    let fileName = keySplit[2];

    let requestUrl = "/files";
    let requestData = {
      fileName,
      resource,
      identifier,
    };

    if (isNoAuth) {
      requestUrl = "/no-auth/files";
      requestData.token = accessToken;
    }

    let data = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: requestData,
    };

    const response = await ezorder.get(requestUrl, data);
    const contentType = response.headers["content-type"];
    console.log("Base64 Response", response);
    let base64 =
      `data:${contentType};base64,` +
      Buffer.from(response.data, "base64").toString("base64");
    // let base64 = `data:${contentType};base64,${response.data}`;
    return base64;
    // return response.data;
  } catch (error) {
    console.log(error);
    throw Error("Unable to load presigned URL", { cause: error });
  }
};

const getOrderByIdAsAdmin = async (orderId, authToken) => {
  try {
    const response = await ezorder.get(`/admin/orders/${orderId}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    console.log("ORDER", response.data);
    return response.data.order;
  } catch (error) {
    throw "UNable to get Order";
  }
};

const getOrderByIdAsCustomer = async (orderId, authToken) => {
  try {
    const response = await ezorder.get(`/orders/${orderId}`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    console.log("ORDER", response.data);
    return response.data.order;
  } catch (error) {
    throw "UNable to get Order";
  }
};

const getOrderByIdWithAccessToken = async (id, accessToken) => {
  try {
    const response = await ezorder.get(
      `/no-auth/orders/${id}?token=${accessToken}`
    );
    //console.log(response.data.order);
    return response.data.order;
  } catch (error) {
    console.log("ERRORRRRR");
    console.log(error);
  }
};

// This is the backend version of the function definition
// const getEstimateDocDefinition = async (
//   order,
//   // ---Provided When Customer Signs/Approves ---
//   isSalesTaxApplicable = false,
//   signeeEmail,
//   signeeFullName,
//   signatureBase64, // This is not really used anymore in V2. All V1 orders are already expired or approved
//   // -------------
//   // -- Provided When Vendor is Printing Out a markup pdf
//   markUpPercentage = 0,
//   includeVendorLogo = false
// ) => {
const getEstimateDocDefinition = async (
  orderId,
  authToken,
  isNoAuth, // decides whether to use authToken or accessToken(no auth)
  accessToken,
  signatureBase64,
  signeeFullName,
  isCustomer = false,
  isSalesTaxApplicable = false,
  markUpPercentage = 0,
  includeVendorLogo = false,
  signeeEmail
) => {
  console.log("Getting Quote PDF Doc Definition");
  let order;
  if (isNoAuth) {
    order = await getOrderByIdWithAccessToken(orderId, accessToken);
  } else {
    if (isCustomer) order = await getOrderByIdAsCustomer(orderId, authToken);
    else order = await getOrderByIdAsAdmin(orderId, authToken);
  }

  let estimateVersion = order.estimateVersion;
  let estimateApprovalSealId = order.estimateApprovalSealId;
  let isItemizedEstimate = order.isItemizedEstimate;

  const productImages = await getProductImages(
    order,
    authToken,
    isNoAuth, // decides whether to use authToken or accessToken(no auth)
    accessToken
  );
  if (signatureBase64 && estimateVersion == "v1") {
    productImages[`Signature`] = signatureBase64;
  }

  let vendorLogo;
  let vendorLogoDimensions;
  if (includeVendorLogo && order.company.logo) {
    vendorLogo = await getVendorLogo(order, authToken, isNoAuth, accessToken);
    vendorLogoDimensions = await getImageDimensions(vendorLogo);
  }

  // Put order items in a map by type
  const productMap = new Map();
  for (let i = 0; i < order.items.length; i++) {
    let orderItem = order.items[i];
    productMap.set(`${orderItem.objectType}`, orderItem);
  }

  let otdCost = applyMarkup(
    Number(order.outTheDoorCost ?? 0),
    markUpPercentage
  );
  let content = [];
  if (order.quoteType === "Free Text") {
    content = [
      ...HEADER(includeVendorLogo, vendorLogo, vendorLogoDimensions),
      ...JOB_DETAILS(order, otdCost), //, qbCustomer),
      ...FREE_TEXT_QUOTE_SUMMARY(order.quoteNotes),
    ];
  } else {
    content = [
      ...HEADER(includeVendorLogo, vendorLogo, vendorLogoDimensions),
      ...JOB_DETAILS(order, otdCost), //, qbCustomer),
      ...SKID_CHARGE(order.skidCharge, markUpPercentage),
      ...ACCESSORIES(productMap.get("Accessory"), otdCost, markUpPercentage),
      ...FLAT_SHEET(productMap.get("FlatSheet"), otdCost, markUpPercentage),
      ...COIL(productMap.get("Coil"), otdCost, markUpPercentage),
      ...TRIM_AND_FLASHING_SUMMARY(
        productMap.get("TrimAndFlashing"),
        productImages,
        isItemizedEstimate,
        markUpPercentage
      ),
      ...COPING_CAP_SUMMARY(
        productMap.get("CopingCap"),
        productImages,
        isItemizedEstimate,
        markUpPercentage
      ),
      ...CLEAT_SUMMARY(
        productMap.get("CopingCapCleat"),
        productImages,
        isItemizedEstimate,
        markUpPercentage
      ),
      ...BENCH_WORK_SUMMARY(
        productMap.get("BenchWork"),
        productImages,
        isItemizedEstimate,
        markUpPercentage
      ),
      ...SPLICE_PLATES(
        productMap.get("SplicePlate"),
        isItemizedEstimate,
        markUpPercentage
      ),
      ...PANEL(
        productMap.get("Panel"),
        order?.calculations?.Panel ?? {},
        productImages,
        markUpPercentage
      ),
      ...TRIM_AND_FLASHING(
        productMap.get("TrimAndFlashing"),
        productImages,
        isItemizedEstimate
      ),
      ...COPING_CAP(
        productMap.get("CopingCap"),
        productImages,
        isItemizedEstimate
      ),
      ...CLEAT(
        productMap.get("CopingCapCleat"),
        productImages,
        isItemizedEstimate
      ),

      ...BENCH_WORK(
        productMap.get("BenchWork"),
        productImages,
        isItemizedEstimate
      ),
      //...END(order),
    ];
  }

  // If there's no splice plate section, add page break before to the signature
  // let addPageBreakToSignature =
  //   productMap.get("SplicePlate") == null &&
  //   productMap.get("SplicePlate") == undefined;
  let addPageBreakToSignature = true;

  // IF UNCONFIRMED CUT LIST, DON'T ADD SIGNATURE
  // IF NOT CONFIRMED CUTLIST, DON'T ADD SIGNATURE
  if (order.quoteType === "Confirmed Cut-List") {
    let signatureSection = {};
    switch (estimateVersion) {
      case "v2":
        signatureSection = SIGNATURE_V2(
          signeeFullName ? new Date() : null, // The full name is the signature. If signed, then add the approved on date
          signeeFullName,
          signeeEmail,
          estimateApprovalSealId,
          isSalesTaxApplicable,
          addPageBreakToSignature
        );
        break;
      default:
        signatureSection = SIGNATURE_V1(
          otdCost,
          signatureBase64,
          signeeFullName,
          isSalesTaxApplicable,
          addPageBreakToSignature
        );
    }
    content = [...content, ...signatureSection];
  }

  let images = {
    checked:
      "data:image/png;base64,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",
    unchecked:
      "data:image/png;base64,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",

    logo: await getBase64FromUrl(
      "https://ezorder-public.s3.us-east-2.amazonaws.com/industry-metal-co-long-logo.png"
    ),
    verified: await getBase64FromUrl(
      "https://ezorder-public.s3.us-east-2.amazonaws.com/verified_icon.png"
    ),
    ...productImages,
  };
  if (vendorLogo && includeVendorLogo) {
    // images.logo =
    images.logo = await getBase64FromUrl(
      "https://ezorder-public.s3.us-east-2.amazonaws.com/industry-metal-co-square-logo.png"
    ); // Square logo
    images.vendorLogo = vendorLogo;
  }

  var docDefinition = {
    pageSize: "A4",
    content: content,

    footer: function (currentPage, pageCount) {
      return {
        margin: [40, 10, 40, 0], // margin: [left, top, right, bottom]
        columns: [
          {
            text: `Created on ${new Date().toDateString()}`,
            alignment: "left",
            style: "footerText",
          },
          {
            text: currentPage.toString() + " of " + pageCount,
            alignment: "center",
            style: "footerText",
          },
          // {
          //   text: "EZ-ORDER Ver.1.0",
          //   alignment: "right",
          //   style: "footerText",
          // },
        ],
      };
    },

    styles: {
      header: {
        fontSize: 24,
        bold: true,
        alignment: "right",
      },
      subheader: {
        bold: true,
        fontSize: 12,
      },
      imageText: {
        fontSize: 10,
        alignment: "center",
      },
      imageTextBold: {
        bold: true,
        fontSize: 10,
        alignment: "center",
      },
      detailName: {
        bold: true,
        fontSize: 10,
      },
      detailValue: {
        fontSize: 8,
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        alignment: "center",
      },
      tableCell: {
        fontSize: 8,
        alignment: "center",
      },
      tableTotal: {
        fontSize: 8,
        bold: true,
        alignment: "center",
      },
      regularText: {
        fontSize: 10,
      },
      materialHeader: {
        fillColor: "#D3D3D3",
        bold: true,
        fontSize: 10,
      },
      checkbox: {},
      footerText: {
        fontSize: 8,
      },
    },
    defaultStyle: {
      fontSize: 12,
    },
    images,
  };

  console.log("DOC DEFINITION", docDefinition);

  return docDefinition;
};

export default getEstimateDocDefinition;
